import { TRadius } from "../utils/types/gui/field.types";

export const generateRadius = (value?: TRadius, defaultValue?: string) => {
  if (!value || Object.keys(value).length === 0) return defaultValue ?? 0;

  const { TopLeft, TopRight, BottomRight, BottomLeft } = value;

  const tl = TopLeft ? TopLeft : 0;
  const tr = TopRight ? TopRight : 0;
  const br = BottomRight ? BottomRight : 0;
  const bl = BottomLeft ? BottomLeft : 0;

  if (tl === tr && tr === br && br === bl) {
    return tl;
  } else if (tl === br && tr === bl) {
    return `${tl} ${tr}`;
  }

  return `${tl} ${tr} ${br} ${bl}`;
};
